import { useCreatorStudioStore } from '../stores/CreatorStudioStore';
import { EventBus } from '../events/event.bus';
import { EVENT_APP_NAVIGATE } from '../events/app.events';

class PromptEditormanager {
    listener = false;
    prompts = [
        {
            name: 'Lighting',
            options: [
                'golden hour, warm glow',
                'blue hour, twilight, ISO12000',
                'midday, direct lighting, overhead sunlight',
                'overcast, whitebox, flat lighting, diffuse',
                'dreamlike diffuse ethereal lighting',
                'dramatic lighting, dramatic shadows, illumination',
                'studio lighting, professional lighting, well-lit',
                'flash photography',
                'low-key lighting, dimly lit',
                'high-key lighting, neutral, flat, even, ambient light',
            ],
        },
        {
            name: 'Angle & framing',
            options: [
                'extreme close-up',
                'close-up',
                'medium shot, waist and torso shot',
                'long shot, wide shot, full body',
                'extreme long shot, extreme wide shot, from a distance',
                'high overhead view, establishing shot, long drone shot',
                'low angle, imposing, from below',
                "satellite photography, bird's eye view, Google Maps Satellite view, (c) Planet Labs",
            ],
        },
        {
            name: 'Lens & Capture',
            options: [
                'Fast shutter speed, 1/1000 sec shutter',
                'Slow shutter speed, long exposure',
                'bokeh, shallow depth of field, background blur',
                'tilt shift photography',
                'motion blur, fast motion capture',
                'macro lens, macro photo, Sigma 105mm f/2.8',
                'wide angle lens, 15mm, ultra-wide shot',
            ],
        },
        {
            name: 'Film selection',
            options: [
                'Kodachrome',
                'Autochrome',
                'Polaroid scan, Instax scan',
                'cameraphone 2007',
                'Camera obscura, pinhole photography',
                'double exposure, award-winning photograph',
                'black and white, tri-x 400TX',
                'bleach bypass',
                'color splash',
                'Instagram, Hipstamatic, 2015',
            ],
        },
        {
            name: 'Art style',
            options: [
                'American newspaper political cartoon sketch, black and white New Yorker cartoon',
                'woodcut painting',
                'charcoal sketch',
                'watercolor',
                'acrylic on canvas',
                'colored pencil, detailed',
                'oil painting',
                'airbrush',
                'Chinese watercolor painting',
                'vector graphics, clipart',
                'watercolor & pen',
                'digital painting',
                'layered paper',
                'low poly, unreal engine, Blender render',
                'isometric 3D, highest quality render',
                'Houdini 3D, Octane render, ZBrush, Blender, highest quality 3D render',
                'claymation',
                'still from Pixar animated short',
                'still from film by Studio Ghibli, Hayao Miyazaki',
                'Renaissance painting, neoclassical, Renoir',
                'Impressionism, Monet, Van Gogh',
                'Rococo, 1730, late Baroque',
                'Art deco, vintage, moderne',
                'Bauhaus, postwar midcentury style, Wassily Kandinsky',
                'surrealist, Magritte, Salvador Dali',
                'urban street photography',
                'Thomas Kinkade',
                'papercraft, origami, highly detailed',
            ],
        },
        {
            name: 'Vibes',
            options: [
                'vaporwave, neon, 80s',
                'post-apocalyptic',
                'gothic, fantasy, lush, mystery',
                'cybernetic, sci-fi, Matrix, glowing',
                'steampunk, metallic, Victoriana',
                'Memphis style, Memphis group, bold, kitch, colorful, geometric',
                'Dieselpunk, grimy, steel, industrial',
                'Afrofuturism, lush, solarpunk',
                'organic, lush, solarpunk, green, sustainable',
            ],
        },
        {
            name: 'Mood',
            options: [
                'light, peaceful, calm, serene, soothing, relaxed, ethereal, delicate',
                'bright, vibrant, dynamic, energetic, vivid, rich, saturated, exciting',
                'muted, bleak, somber, melancholic, gloomy, sad, desaturated, dull, dim',
                'dark, ominous, haunting, forboding, gloomy, stormy, sinister, shadowy, harrowing',
            ],
        },
        {
            name: 'Scale',
            options: [
                'grand, high-scale, monumental, imposing, manmade, superstructure, perspective',
                'ornate, delicate, precise, opulent, elegant, ornamental, fine, intricate, decorative',
                'microscopic, tiny, invisible',
            ],
        },
    ];
    surprise_me_prompts = [
        'imagine a surreal art house scene with abstract elements and a young woman as the main object, demonstrating the beauty and chaos of nature.hyper-detailed. Cinematic. Color Grading.',
        "the girl's face consists of galaxies and nebulae, Chris LaBrooy, nebula, a matte painting, space art",
        'ilya kuvshinov with long sky blue hair, gold eyes, professional digital painting, concept art, unreal engine 5, 8 k, cinematic, wlop, bubbles, tendrils in the background, art by greg rutkowski, pixiv art, junji ito, yoshitaka amano',
        'african hydropunk princess, science fiction, highly detailed, digital painting, beautiful eyes, symmetry, concept art, sharp focus, illustration, global illumination, radiant light, synthwave colors, detailed and intricate environment, art by artgerm and greg rutkowski and magali villeneuve and ilya kuvshinov!',
        'a very beautiful anime cute girl, full body, long wavy blond hair, sky blue eyes, full round face, short smile, fancy top, miniskirt, front view, medium shot, mid-shot, laying in bed, highly detailed, cinematic wallpaper by Stanley Artgerm Lau',
        'beautiful gen Z model focusing on camera,wearing a single stone jewelery,close up, amazing background, amazing lighting',
        'symmetry!! portrait of a female sorcerer, dar fantasy, intricate, elegant, highly detailed, my rendition, digital painting, artstation, concept art, smooth, sharp focus, illustration, art by artgerm and greg rutkowski and alphonse mucha and huang guangjian and gil elvgren and sachin teng',
        'fullbody!! dynamic movement pose, beautiful ethnic woman with flowing hair, big natural horns on her head, gold jewellery, dnd, face, fantasy, intricate, elegant, highly detailed, digital painting, artstation, concept art, smooth, sharp focus, illustration, art by artgerm and greg rutkowski and alphonse mucha',
        'beautiful digital painting of a stylish asian female forest with high detail, 8 k, stunning detail, works by artgerm, greg rutkowski and alphonse mucha, unreal engine 5, 4 k uhd',
        'portrait of mechanical angel with crystal wings, dark, piercing eyes, gentle expression, metal clothing, photorealistic, highly detailed, artstation, smooth, sharp focus, art by michael whelan, artgerm, greg rutkowski and alphonse mucha',
        'Close-up of a woman (beautiful fantasy empress), digital fantasy art, magnificent digital art, beautiful magnificent digital art, Karol Bak style, complex digital art, beautiful fantasy portrait, very beautiful digital art, beautiful digital artwork, intricate blow, digital fantasy art, Tanya Shatseva style, (( to the throne in sunflower shaped, neon blue eyes))',
        'a portrait of a mayan quetzalcoatl goddess with a lazer shining into the top of her head, pieces expanding from impact aquamarine and red, by android jones, by ben ridgeway, by ross draws, by Noah Bradley, by Maciej Kuciara + illustrative + visionary art + low angle + oil painting + Visionary art, DMT, psychedelic, The god particle, utopia profile, artgerm, featured in artstation, elegant, Moebius, Greg rutkowski',
        "the asian woman's face consists of galaxies and nebulae, Chris LaBrooy, nebula, a matte painting, space art",
        'girl with super long hair, hair becoming autumn red leaves, art by artgerm and alphonse mucha',
        'a woman with many butterflies on her face. beautiful highly detailed face. painting by artgerm and greg rutkowski and alphonse mucha',
        'portrait of a beautiful goddess, soft hair, half body, medieval, ornate, hairy, d & d, fantasy, intricate, elegant, highly detailed, digital painting, artstation, concept art, smooth, sharp focus, illustration, art by artgerm and greg rutkowski and alphonse mucha',
        'a beautiful red haired melancholic girl in white dress sitting on wooden trunk in a garden holding a bunch of wild flowers, beautifull face, deep focus, d & d, fantasy, intricate, elegant, highly detailed, digital painting, artstation, concept art, matte, sharp focus, illustration, octane render, hearthstone, well rendered, art by artgerm and greg rutkowski and alphonse mucha',
        'Portrait of a cute elegant woman with thick angelic white wings on her back, flying, cat ears, luxurious neckless, sunset warm spring, slim face, detailed face, centered close-up, fantasy, anime, vibrant, colorful, depth of field, intricate details, trending on ArtStation, Deviantart, by WLOP',
        'a beautiful portrait of an empress in her garden, with a brilliant, impossible striking big flower headpiece, clothes entirely made out of flowers, symmetrical, closeup, dramatic studio lighting, rococo, baroque, jewels, asian, hyperrealism, D&D, fantasy, intricate, elegant, highly detailed, digital painting, artstation, octane render, 8k, concept art, matte, sharp focus, illustration, art by Artgerm and Greg Rutkowski and Alphonse Mucha',
        'photorealistic an oriental female humanoid with freckle cheeks, cyber neon lightings, futurism, cyberpunk high fashion, elegant profile pose, intricate details, crispy quality, digital photography, trending in artstation, trending in pinterest, no watermark signature, cinematic, 4 k ultra hd, art by artgerm, art by greg rutkowski, art by pascal blanch',
    ];
    constructor() {}

    addPrompt(prompt) {
        this.store = useCreatorStudioStore();
        this.settings = this.store.getSettings();

        if (this.settings.prompt_modifier.includes(prompt)) {
            this.settings.prompt_modifier = this.settings.prompt_modifier.filter((option) => option != prompt);
        } else {
            this.settings.prompt_modifier.push(prompt);
        }
    }

    deletePrompt(prompt) {
        this.store = useCreatorStudioStore();
        this.settings = this.store.getSettings();
        this.settings.prompt_modifier = this.settings.prompt_modifier.filter((option) => option != prompt);
    }

    surpriseMe(data) {
        this.store = useCreatorStudioStore();
        this.settings = this.store.getSettings();
        const randomPrompt = this.surprise_me_prompts[Math.floor(Math.random() * this.surprise_me_prompts.length)];
        this.settings.prompt = randomPrompt;
        EventBus.$emit(EVENT_APP_NAVIGATE, `/${data.id}/prompt_editor`, {});
    }
}

export default new PromptEditormanager();
